(function () {
  var LOOP_TIMEOUT_MS = 200;
  var LOOP_MAX = 20;
  var loop_count = 0;
  var pathParts = (contextPath || window.location.pathname).split("/");
  // Look for market id
  var market = window.siteId;
  // If not found, pull from the path
  if (!market) {
    market = pathParts[1];
  }
  var elementId = "startChat";
  var chatNameString = null;
  if (
    window.location.pathname.split("/").indexOf("account-management-team") >= 0
  ) {
    var elementToHide = elementId;
    var hideInterval = setInterval(function(){
        if(document.querySelector('#startChat')){
            clearInterval(hideInterval);
            document.querySelector('#startChat').style.display = 'none';
        }
    }, LOOP_TIMEOUT_MS);
    elementId = "startAccountManagementChat";
    chatNameString = "&chat=Account Management Chat";
  }
  buildChatHandler();
  function buildChatHandler() {
    var ele = document.getElementById(elementId);
    // clone and replace element to disconnect CCT
    if (!ele) {
      loop_count++;
      if (loop_count >= LOOP_MAX) {
        console.log("Unable to bind chat");
        return;
      }
      setTimeout(buildChatHandler, LOOP_TIMEOUT_MS);
      return;
    }
    var lang = "en_US";
    try {
      lang = document.querySelector("html").attributes.lang.value;
      if (!lang || lang.length === 0) {
        lang = pathParts[2];
      }
      // handle more language transforms
      if (lang === "fr" || lang === "en") {
        lang = lang + "_" + market;
      }
      if (lang === "es") {
        lang = "es_US";
      }
      if (lang === "zh") {
        lang = "zh_CN";
      }
    } catch (err) {
      // keep default
    }
    try {
      // ensure jQuery drops any bound click handlers that might pre-empt us
      $(ele).unbind("click");
    } catch (err) {
      console.log(err);
    }
    // Add event listener as click handler to open page in new tab
    ele.addEventListener(
      "click",
      function (e) {
        window.open(
          "https://help.doterra.com/s/talktous-chat?market=" +
            market +
            "&language=" +
            lang +
            (chatNameString || ""),
          "_blank"
        );
        e.stopPropagation();
        e.preventDefault();
      },
      { capture: true }
    );
  }
})();